import { HTTP } from "@/helpers/http-common"

const url = "/api/talento"

const save = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/save`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const update = (data) => new Promise((resolve, reject) => {
  HTTP.put(`${url}/update`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const exist = (email, nombre) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/exist`, { email, nombre }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const token = (email, token) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/token`, { email, token }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const existeTelefono = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/existeTelefono`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const ipinfo = () => new Promise((resolve, reject) => {
  HTTP.get("https://ipinfo.io/json?token=e7543dff37e893"
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

export default {
  save
  , update
  , exist
  , token
  , existeTelefono
  , ipinfo
}



// WEBPACK FOOTER //
// ./src/services/talento/index.js